import {initElements} from "../define/shared";

export default function initDropdown() {
    initElements(".dropdown", dropdown => {
        dropdown.addEventListener("click", () => {
            dropdown.classList.toggle("is--open");
        });

        document.addEventListener("click", (e) => {
            if (!dropdown.contains(e.target)) {
                dropdown.classList.remove("is--open");
            }
        });
    });
}
